import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { ButtonType } from './index'

const blackLnk = () => css`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    fill: ${theme.colors.white};
    height: 24px;
    font-size: 10px;
    background: ${theme.colors.black};
    border-color: ${theme.colors.black};
    border-radius: 10px 0px 0px 10px;
    padding-left: 8px;
    padding-right: 4px;
    right: 0;
    bottom: 27px;

    &:disabled {
      color: ${theme.colors.white};
      fill: ${theme.colors.white};
      background: ${theme.colors.black};
      border-color: ${theme.colors.black};
    }
  `}
`

const blackLnkFull = () => css`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    fill: ${theme.colors.white};
    background: ${theme.colors.black};
    border-color: ${theme.colors.black};
    font-size: 9px;
    border-radius: 10px;
    height: 22px;
    padding: 4px 9px;
    margin-left: 12px;
    position: relative;

    &:disabled {
      color: ${theme.colors.white};
      fill: ${theme.colors.white};
      background: ${theme.colors.black};
      border-color: ${theme.colors.black};
    }
  `}
`

const globalCss = css<ButtonType>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  white-space: nowrap;
  outline: none;
  transition: 0.3s;
  font-weight: bold;
  border: 1px solid transparent;
  position: absolute;

  ${({ themetype = 'black' }) => css`
    ${themetype === 'black' && blackLnk()}
    ${themetype === 'blackFull' && blackLnkFull()}
  `}
  & > svg {
    & + span {
      margin-left: 4px;
    }
  }

  & > span {
    & + svg {
      margin-right: 4px;
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const StyledButton = styled.button<ButtonType>`
  ${globalCss}
`

export const StyledButtonLink = styled(Link)<ButtonType>`
  ${globalCss}
`
